import posthog from 'posthog-js'
import * as Sentry from '@sentry/vue'
import router from '@urgent/router'

const projectId: any = import.meta.env.TEMBO_STAGE === 'prod' ? 'dashboard-ui' : 'dashboard-ui-staging'
const dsn =
  import.meta.env.TEMBO_STAGE === 'prod'
    ? 'https://19d5b7e738e7d8db80fa27f1c5524a2c@o4508451380723712.ingest.us.sentry.io/4508461874479104'
    : 'https://815faf876b7d7b08f754691aca098de1@o4508451380723712.ingest.us.sentry.io/4508461852393472'

export default {
  install(app) {
    Sentry.init({
      app,
      enabled: import.meta.env.DEV !== true,
      dsn,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        posthog.sentryIntegration({
          organization: 'tembo-health',
          projectId,
        }),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/.*\.tembohealth\.com/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  },
}
